import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { BsClipboard } from 'react-icons/bs';

type BootstrapLogPreviewModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  logs: string;
};

export default function BootstrapLogPreviewModal({
  open,
  setOpen,
  logs,
}: BootstrapLogPreviewModalProps) {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(logs || '');
  };

  return (
    <Modal
      show={open}
      onHide={() => setOpen(false)}
      size="xl"
      centered
      contentClassName="border-0 shadow-lg"
    >
      <Modal.Header closeButton className="bg-white border-bottom">
        <Modal.Title style={{ fontSize: '22px' }}>Log Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-white p-4">
        <div className="d-flex justify-content-end mb-3">
          <Button
            variant="outline-secondary"
            onClick={copyToClipboard}
            className="d-inline-flex align-items-center gap-2"
          >
            <BsClipboard />
            Copy
          </Button>
        </div>
        <div
          style={{
            fontFamily: 'monospace',
            fontSize: '14px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            padding: '16px',
            borderRadius: '8px',
            maxHeight: '420px',
            overflowY: 'auto',
            whiteSpace: 'pre-wrap',
            lineHeight: '1.5',
            color: '#333',
          }}
        >
          {(logs || '').trim() || 'No logs available.'}
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-white border-top">
        <Button variant="outline-secondary" onClick={() => setOpen(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
